import React from 'react'
import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react'
import { FaArrowDown, FaArrowUp, FaInfoCircle } from 'react-icons/fa'
import { StatCardProps } from '../types'

const StatCard: React.FC<StatCardProps> = ({ 
  arrowType, 
  bg, 
  helpText, 
  label, 
  value 
}) => (
  <Box 
    bg={bg} 
    borderRadius="md" 
    boxShadow="sm" 
    p={4}
    transition="transform 0.2s"
    _hover={{ transform: 'translateY(-2px)' }}
  >
    <Flex align="center" justify="space-between" mb={1}>
      <Text color="gray.500" fontSize="sm" fontWeight="medium">
        {label}
      </Text>
      {helpText && (
        <Tooltip hasArrow label={helpText} placement="top">
          <Box as="span">
            <Icon as={FaInfoCircle as any} color="gray.400" h={3} w={3} />
          </Box>
        </Tooltip>
      )}
    </Flex>
    
    <Flex align="center">
      <Text fontSize="xl" fontWeight="bold">
        {value}
      </Text>
      {arrowType && (
        <Icon 
          as={(arrowType === 'increase' ? FaArrowUp : FaArrowDown) as any} 
          color={arrowType === 'increase' ? 'green.400' : 'red.400'} 
          ml={2} 
        />
      )}
    </Flex>
  </Box>
)

export default StatCard
